module.exports = __webpack_public_path__ + "img/advantage_01.38c55bd9.png";